<template lang="pug">
  .choice-source
    .mb-6
      h3.mb-2 Создание видеоконференции
      span {{ date | dp('d MMMM') }}
    template(v-if="value.commited")
      v-row(
        no-gutters
        align="center"
      )
        template(v-if="value.conferenceSource === $conf.CONFERENCE_SOURCE.telegram")
          v-icon(size=50 color="secondary lighten-1") $telegram
          div
            span Telegram
            .caption Площадка проведения
        template(v-else)
          div
            span Sber Jazz
            .caption Площадка проведения

    template(v-if="!value.commited")
      v-list-item-subtitle Выберите площадку для видеоконференции
      v-btn-toggle(
        v-model="conferenceSource"
        mandatory
        color="secondary lighten-1"
      ).mt-3.grey.lighten-5
        v-btn(
          :value="$conf.CONFERENCE_SOURCE.telegram"
        ).px-5
          v-icon(size=40 left color="secondary") $telegram
          span Телеграм
        v-btn(
          :value="$conf.CONFERENCE_SOURCE.jazz"
        ).px-5
          span Sber Jazz
      v-alert(
        type="info"
        color="secondary lighten-1"
        text
        outlined
      ).mt-5
        template(v-if="conferenceSource === $conf.CONFERENCE_SOURCE.telegram")
          h2.mb-3 Telegram
          p  Рекомендуемый инструмент для создания трансляций.
          ul.mb-3
            li.my-3  Можно создать вебинары для неограниченного круга лиц.
            li.my-3  Можно создать трансляцию как для конкретного урока, так и без привязки к нему.
            li.my-3  Можно создать трансляцию для нескольких выбранных курсов,
              |  групп из разных курсов или отдельных обучающихся.
              |  Будет запланирована трансляция в чате телеграмм курса/группы,
              |  либо создан отдельный чат, в который получат доступ участники трансляции.
          span  Запуск трансляции и ее проведение осуществляется с использованием Telegram.
        template(v-else)
          h2.mb-3 Sber Jazz
          p  Инструмент для удобного проведения уроков
          ul.mb-3
            li.my-3  Можно создать трансляции для конкретных уроков,
              |  включенных в курсы, которые вы ведете.
            li.my-3  Можно создать урок сразу для нескольких групп курса
          span Подключение участников и проведение трансляции
            |  осуществляется прямо в личных кабинетах
      v-btn(
        color="grey lighten-3"
        depressed
        @click="commitValue"
      ).mt-5 Продолжить
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({ commited: false }) },
    date: { type: String, default: null },
  },
  data() {
    return {
      conferenceSource: null,
    };
  },
  methods: {
    commitValue() {
      return this.$emit('input', {
        conferenceSource: this.conferenceSource,
        commited: true,
      });
    },
  },
};
</script>
